// import { useEffect, Fragment } from "react";
// import { Outlet, useLocation, useNavigate } from "react-router-dom";

// const PublicRoutes = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     useEffect(() => {
//         const authToken = localStorage.getItem("token");
//         // if (authToken) {
//         //     navigate("/", {
//         //         replace: true,
//         //     });
//         // }
//     }, [location.pathname]);

//     return (
//         <Fragment>
//             <Outlet />
//         </Fragment>
//     );
// };

// export default PublicRoutes;

import React from "react";
import { Route, Redirect } from "react-router-dom";

const PublicRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = !!localStorage.getItem("token");

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Redirect to="/clear-sample" />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

export default PublicRoute;
